import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";

import Home from "./pages/home/Home";
import Search from "./pages/search/Search";
import Profile from "./pages/profile/Profile";
import Settings from "./pages/setting/Setting";
import Messages from "./pages/messages/Messages";
import Booking from "./pages/booking/Booking";
import Events from "./pages/events/Events";
import Following from "./pages/following/Following";
import Header from "./components/header/Header";
import SideMenu from "./components/sidemenu/SideMenu";
import SignUp from "./components/signup/SignUp";
import EmailCode from "./components/emailcode/EmailCode";
import CreatePassword from "./components/createpassword/CreatePassword";
import PersonaVerification from "./components/personaverification/PersonaVerification";
import SignupCategory from "./components/signupcategory/SignupCategory";
import Subscription from "./components/subscriptionform/Subscription";
import SetupYourProfile from "./components/setupyourprofile/SetupYourProfile";
import SubmitSetupForm from "./components/submitsetupform/SubmitSetupForm";
import Splash from "./components/splash/Splash";
import VideoCall from "./components/videoCall/VideoCall";
import Worker from "./components/worker/Worker";
import BookingService from "./components/bookingService/BookingService";
import AddService from "./components/addService/AddService";
import ClientProfile from "./components/clientProfile/ClientProfile";
import SugarDaddy from "./components/sugarDaddy/SugarDaddy";
import EnterEmail from "./components/enterEmail/EnterEmail";
import ProtectedRoute from "./router/ProtectedRoute";
import Login from "./components/login/Login";
import Services from "./pages/service/Services";
// import ProfilePostsStories from "./components/ProfilePostsStories/ProfilePostsStories";

// Login Page Component (Placeholder)
// const Login = () => <div>Login Page</div>;

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [showHeaderAndMenu, setShowHeaderAndMenu] = useState(true);
  const navigate = useNavigate(); // for navigation

  const location = useLocation();

  useEffect(() => {
    // Simulate a loading period (e.g., fetching data)
    const timer = setTimeout(() => {
      setIsLoading(true);
    }, 3000); // Show splash screen for 3 seconds

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Paths where Header and SideMenu should not appear
    const pathsWithoutHeaderAndMenu = [
      "/login",
      "/signup",
      "/enter-email",
      "/email-verify",
      "/create-password",
      "/persona-verification",
      "/signup-category",
      "/subscription",
      "/setup-your-profile",
      "/submit-form",
    ];
    setShowHeaderAndMenu(!pathsWithoutHeaderAndMenu.includes(location.pathname));
  }, [location]);

  // Function to handle splash click and navigate to Home
  const handleSplashClick = () => {
    setIsLoading(false); // Stop loading state
    navigate("/home"); // Redirect to home page
  };

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      // transition={Bounce}
      />
      {isLoading ? (
        <Splash onClick={handleSplashClick} /> // Pass the click handler to Splash
      ) : (
        <>
          {showHeaderAndMenu && <Header />}
          <div className="dashboard-main-content d-flex flex-wrap">
            {showHeaderAndMenu && <SideMenu />}
            <Routes>
              <Route path="/" element={<ProtectedRoute element={<Home />} requiredRoles={['Customer', 'Sugar Daddy', 'Worker']} />} />
              <Route path="/home" element={<ProtectedRoute element={<Home />} requiredRoles={['Customer', 'Sugar Daddy', 'Worker']} />} />
              <Route path="/search" element={<Search />} />
              <Route path="/profile" element={<ProtectedRoute element={<Profile />} requiredRoles={['Customer', 'Sugar Daddy', 'Worker']} />} />
              <Route path="/setting" element={<Settings />} />
              <Route path="/message" element={<Messages />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/events" element={<Events />} />
              <Route path="/following" element={<Following />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/enter-email" element={<EnterEmail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/email-verify" element={<EmailCode />} />
              <Route path="/create-password" element={<CreatePassword />} />
              <Route path="/persona-verification" element={<PersonaVerification />} />
              <Route path="/signup-category" element={<SignupCategory />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/setup-your-profile" element={<SetupYourProfile />} />
              <Route path="/submit-form" element={<SubmitSetupForm />} />
              <Route path="/videocall" element={<VideoCall />} />
              <Route path="/worker" element={<Worker />} />
              <Route path="/booking-service" element={<BookingService />} />
              <Route path="/add-service" element={<AddService />} />
              <Route path="/client-profile/:id" element={<ClientProfile />} />
              <Route path="/sugar-daddy" element={<SugarDaddy />} />
              <Route path="/services" element={<Services />} />
              {/* <Route path="/profile-posts-storie" element={<ProfilePostsStories />} /> */}
              {/* <Route path="/SearchService" element={<SearchService />} /> */}
            </Routes>
          </div>
        </>
      )}
    </div>
  );
}

export default function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
